import React from "react";
import ContentLoader from "react-content-loader";

const CartLoader = () => (
  <ContentLoader height={300} width={600} speed={4}>
    <rect x="80" y="10" rx="4" ry="4" width="300" height="13" />
    <rect x="80" y="32" rx="3" ry="3" width="64" height="18" />
    <circle cx="33" cy="33" r="33" />
    <rect x="80" y="60" rx="3" ry="3" width="64" height="17" />
    <rect x="309" y="63" rx="3" ry="3" width="64" height="16" />
    <rect x="401" y="6" rx="0" ry="0" width="210" height="167" />
  </ContentLoader>
);

export default CartLoader;
